<template>
    <ui-mini-crud :fetch="() => (equipment.usageLogs || [])" empty-state-text="This equipment has not yet been used.">
        <template #show="{ item }">
            <ui-mini-crud-card :title="item.packageReference?`Package #`+item.packageReference:'-- No Package Referenced --'" :subtitle="item.contact">
                <p class="mt-2 text-gray-500 text-sm">
                    <span class="font-semibold">Out: </span>
                    <span class="whitespace-pre-wrap">{{ item.dateOut }} • {{ item.conditionOut }}</span>
                </p>
                <p class="mt-2 text-gray-500 text-sm" v-if="item.dateIn">
                    <span class="font-semibold">In: </span>
                    <span class="whitespace-pre-wrap">{{ item.dateIn }} • {{ item.conditionIn }}</span>
                </p>
            </ui-mini-crud-card>
        </template>
    </ui-mini-crud>
</template>

<script>
export default {
    props: {
        equipment: Object,
    }
}
</script>
